import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      pageType: 'login',
      forgetPasswordPhoneNumer: '',
      forgetPasswordToken: '',
      selectedExtension: null,
      userRoleEnglishTitle: '',
      userRoleIdForLogin: null,
      selectedZone: null,
      countDown: 120,
      forgetPassword: '',
      forgetPasswordRepeat: '',
      forgetPasswordIcon: 'mdi-eye',
      forgetPasswordClass: 'password',
      forgetPasswordRepeatClass: 'mdi-eye',
      forgetPasswordRepeatIcon: 'password',
      //1 defined 2 not defined 3 wating
      defined: 1,
      computerText: 'کاربر گرامی، کامپیوتر شما در سامانه ثبت نشده است.',
      computerNote: '',
      validateuniqueId: {},
    };
  },
  methods: {
    ChangePage: function (type) {
      if (type == 'password') {
        this.pageType = 'password';
      }
    },
    make115UserReadyForLogin: function () {
      this.pageType = 'extension';
      this.getListOfExtensions();
    },
    make800UserReadyForLogin: function () {
      this.pageType = 'extension';
      this.getListOfExtensions();
    },
    makeAdmissionUserReadyForLogin: function () {
      this.pageType = 'extension';
      this.getListOfExtensions();
    },
    confirmedExtension: function () {
      if (!this.selectedExtension) {
        this.snackText = 'لطفا داخلی را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      this.setExtensionFunction(this.selectedExtension);
    },
    checkForLoginUser: function () {
      if (this.userRoleEnglishTitle == 'User115') {
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'dashboard115' });
      } else if (this.userRoleEnglishTitle == 'User800') {
        this.pageType = 'zone';
        this.getAllZones();
      } else if (this.userRoleEnglishTitle == 'Admission') {
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'admissionMap' });
        // const routeData = this.$router.resolve({ name: 'dashboardAdmission' });
        const routeData = this.$router.resolve({ name: 'admissionMissions' });
        window.open(routeData.href, '_blank');
      } else if (this.userRoleEnglishTitle == 'Doctor') {
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'doctorDashboard' });
      } else if (this.userRoleEnglishTitle == 'EOC') {
        this.pageType = 'zone';
        this.getAllZones();
      }
    },
    confirmedZone: function () {
      if (!this.selectedZone) {
        this.snackText = 'لطفا ناحیه را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      this.setZoneFunction(this.selectedZone);
    },
    checkForLogin800User: function () {
      let id = this.userRoleIdForLogin.toString();
      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
      localStorage.setItem('dash', encryptId);
      this.setTheme('red');
      this.$router.push({ name: 'dispatchMap' });
      const routeData = this.$router.resolve({ name: 'dashboard800' });
      window.open(routeData.href, '_blank');
    },
    //forrgeeet password
    backToLogin: function () {
      this.pageType = 'login';
      this.forgetPasswordPhoneNumer = '';
    },
    sendPhoneNumberForgetPassword: function () {
      if (!this.forgetPasswordPhoneNumer) {
        this.snackText = 'لطفا شماره همراه را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.forgetPasswordPhoneNumer.length < 11) {
        this.snackText = 'شماره همراه معتبر نیست';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      this.otpRequestForForgetPasswordFunction(this.forgetPasswordPhoneNumer);
    },
    successForgetPasswordOtpRequest: function () {
      this.forgetPasswordToken = '';
      this.countDown = 120;
      this.pageType = 'forgetPasswodToken';
      this.countDownTimer();
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    sendTokenForgetPassword: function () {
      if (!this.forgetPasswordToken) {
        this.snackText = 'لطفا کد تایید را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.forgetPasswordToken.length < 6) {
        this.snackText = 'کد تایید معتبر نیست';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      this.otpVerifyForForgetPasswordFunction(
        this.forgetPasswordPhoneNumer,
        this.forgetPasswordToken,
      );
    },
    backToPhoneNumberPage: function () {
      this.pageType = 'password';
      this.forgetPasswordToken = '';
      this.countDown = 120;
    },
    successForgetPasswordOtpVerify: function () {
      this.pageType = 'forgetPasswordSetPassword';
    },
    showForgetPasswordPassword: function (type) {
      if (type == 1) {
        if (this.forgetPasswordIcon == 'mdi-eye') {
          this.forgetPasswordIcon = 'mdi-eye-off';
          this.forgetPasswordClass = '';
        } else if (this.forgetPasswordIcon == 'mdi-eye-off') {
          this.forgetPasswordIcon = 'mdi-eye';
          this.forgetPasswordClass = 'password';
        }
      } else if (type == 2) {
        if (this.forgetPasswordRepeatIcon == 'mdi-eye') {
          this.forgetPasswordRepeatIcon = 'mdi-eye-off';
          this.forgetPasswordRepeatClass = '';
        } else if (this.forgetPasswordRepeatIcon == 'mdi-eye-off') {
          this.forgetPasswordRepeatIcon = 'mdi-eye';
          this.forgetPasswordRepeatClass = 'password';
        }
      }
    },
    setForgetPassword: function () {
      if (!this.forgetPassword) {
        this.snackText = 'لطفا رمز عبور را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.forgetPassword !== this.forgetPasswordRepeat) {
        this.snackText = 'رمز عبور با تکرار آن برابر نیست';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      this.setOTPChangePasswordFunction();
    },
    goToDefineComputer: function () {
      this.pageType = 'computer';
    },
    backToHomePage: function () {
      this.pageType = 'login';
      this.computerNote = '';
    },
    addComputerRequest: function () {
      if (!this.computerNote) {
        this.snackText = 'لطفا توضیحات را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.computerNote.replace(/\s/g, '').length) {
        this.snackText = 'لطفا توضیحات را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      let uniqeId = this.gnerateUniqeId(16);
      this.addClientComputerRequestFunction(this.computerNote, uniqeId);
    },
    getExpireTime: function () {
      const today = new Date();
      const expireTime = today.setDate(today.getDate() + 3660);
      return expireTime;
    },
    requestAdded: function (uniqeId) {
      this.$cookies.set('CINF', uniqeId);
      this.defined = 3;
      this.pageType = 'login';
      this.computerNote = '';
    },

    gnerateUniqeId: function (length) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      let counter = 0;
      while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
      }
      return result;
    },
  },
};
